<!--suppress SpellCheckingInspection -->
<template>
  <Form :model="currentOrder" :label-width="160" label-position="right" ref="orderForm" :rules="rules">

    <div class="c-gray m-b-15 f-14">
      <h4>企业信息</h4>
    </div>
    <form-item label="营业执照：" prop="usccOss">
      <photo-upload v-model="currentOrder.usccOss" :success="ocrSetup.usccOss.success"
                    :param="ocrSetup.usccOss.param"></photo-upload>
    </form-item>
    <FormItem label="企业名称：" prop="name">
      <Input v-model="currentOrder.name" placeholder="请输入企业名称" style="width:70%"></Input>
    </FormItem>
    <FormItem label="统一社会信用代码：" prop="uscc">
      <Input v-model="currentOrder.uscc" placeholder="请输入统一社会信用代码" style="width:43%"></Input>
    </FormItem>
    <FormItem label="注册地址：" prop="address">
      <Input v-model="currentOrder.address" placeholder="请输入注册地址" style="width:70%" ref="companyAddressText"></Input>
    </FormItem>
    <FormItem label="所在县区：" prop="dist6">
      <TuboDist v-model="currentOrder.dist6" dict-name="dist.support" style="width:43%" :clearable="true"></TuboDist>
    </FormItem>

    <div class="c-gray m-b-15 f-14">
      <h4>法定代表人</h4>
    </div>
    <Row style="width:70%">
      <Col span="12">
        <FormItem label="身份证正面：" prop="crpCertFrontOss">
          <PhotoUpload v-model="currentOrder.crpCertFrontOss" :success="ocrSetup.crpCertFrontOss.success"
                       :param="ocrSetup.crpCertFrontOss.param"></PhotoUpload>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem label="身份证反面：" prop="crpCertBackOss">
          <PhotoUpload v-model="currentOrder.crpCertBackOss"></PhotoUpload>
        </FormItem>
      </Col>
    </Row>
    <FormItem label="姓名：" prop="crpName">
      <Input v-model="currentOrder.crpName" placeholder="请输入法人代表姓名" style="width:43%"></Input>
    </FormItem>
    <FormItem label="身份证号：" prop="crpCertNo">
      <Input v-model="currentOrder.crpCertNo" placeholder="请输入法人代表身份证号" style="width:43%"></Input>
    </FormItem>
    <FormItem label="预留手机：" prop="crpPhone">
      <Input v-model="currentOrder.crpPhone" placeholder="请输入法人代表手机号" style="width:43%"></Input>
    </FormItem>

    <div class="c-gray m-b-15 f-14">
      <h4>经办人</h4>
    </div>
    <FormItem label="经办人同法人">
      <i-switch v-model="currentOrder.opSameWithCrp" @on-change="setOpSameWithCrp">
        <span slot="open">开</span>
        <span slot="close">关</span>
      </i-switch>
    </FormItem>
    <div v-if="!currentOrder.opSameWithCrp">
      <Row style="width:70%">
        <Col span="12">
          <FormItem label="身份证正面：" prop="opCertFrontOss">
            <PhotoUpload v-model="currentOrder.opCertFrontOss" :success="ocrSetup.opCertFrontOss.success"
                         :param="ocrSetup.opCertFrontOss.param"></PhotoUpload>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="身份证反面：" prop="opCertBackOss">
            <PhotoUpload v-model="currentOrder.opCertBackOss"></PhotoUpload>
          </FormItem>
        </Col>
      </Row>
      <FormItem label="姓名：" prop="opName">
        <Input v-model="currentOrder.opName" placeholder="请输入经办人姓名" style="width:43%"></Input>
      </FormItem>
      <FormItem label="身份证号：" prop="opCertNo">
        <Input v-model="currentOrder.opCertNo" placeholder="请输入经办人身份证号" style="width:43%"></Input>
      </FormItem>
      <FormItem label="预留手机：" prop="opPhone">
        <Input v-model="currentOrder.opPhone" placeholder="请输入经办人手机号" style="width:43%"></Input>
      </FormItem>
      <FormItem label="法人授权委托书：" prop="opPoaOss">
        <PhotoUpload v-model="currentOrder.opPoaOss"></PhotoUpload>
      </FormItem>
    </div>

    <div class="c-gray m-b-15 f-14">
      <h4>其它信息</h4>
    </div>
    <FormItem label="补充材料：" prop="matOssArrayJson">
      <PhotoUpload v-model="currentOrder.matOssArrayJson" :single="false"></PhotoUpload>
    </FormItem>
    <FormItem label="备注：" prop="notes">
      <Input type="textarea" v-model="currentOrder.notes" placeholder="请输入备注" style="width:70%"></Input>
    </FormItem>

  </Form>
</template>

<script>
  import {PhotoUpload} from '@/components/libs'
  import {mapState} from 'vuex'
  import {util} from '@/libs'

  export default {
    name: 'OrderCompanySelf',
    components: {PhotoUpload},
    data() {
      let that = this;
      return {
        rules: {
          // company
          usccOss: [{required: true, trigger: 'blur', message: '营业执照图像不能为空'}],
          uscc: [{required: true, trigger: 'blur', message: '信用代码不能为空'}],
          name: [{required: true, trigger: 'blur', message: '企业名称不能为空'}],
          address: [{required: true, trigger: 'blur', message: '注册地址不能为空'}],
          dist6: [{required: true, trigger: 'change', message: '请选择所在县区'}],
          // crp
          crpCertFrontOss: [{required: true, trigger: 'blur', message: '请上传法人代表身份证正面'}],
          crpCertBackOss: [{required: true, trigger: 'blur', message: '请上传法人代表身份证背面'}],
          crpName: [{required: true, trigger: 'blur', message: '法人代表姓名不能为空'}],
          crpCertNo: [{required: true, trigger: 'blur', message: '请填写正确的身份证号'}],
          crpPhone: [{required: true, trigger: 'blur', pattern: util.pattern.phone, message: '请填写正确的手机号'}],
          // op
          opCertFrontOss: [{required: true, trigger: 'blur', message: '经办人身份证正面图像不能为空'}],
          opCertBackOss: [{required: true, trigger: 'blur', message: '经办人身份证背面图像不能为空'}],
          opName: [{required: true, trigger: 'blur', message: '经办人姓名不能为空'}],
          opCertNo: [{required: true, trigger: 'blur', message: '经办人身份证号不能为空'}],
          opPhone: [{required: true, trigger: 'blur', pattern: util.pattern.phone, message: '经办人预留手机不能为空'}],
          opPoaOss: [{required: true, trigger: 'blur', message: '授权委托书图像不能为空'}],
        },
        ocrSetup: {
          usccOss: {
            param: {ocrType: '3'},
            success: function (payload) {
              Object.assign(that.currentOrder, {
                usccOss: payload.ossPath,
                name: payload.ocr.name,
                crpName: payload.ocr.person,
                uscc: payload.ocr.reg_num,
                dist6: payload.ocr.reg_num.substr(2, 6),
                address: payload.ocr.address,
                // aicScope
              })
              that.$forceUpdate()
            },
          },
          crpCertFrontOss: {
            param: {ocrType: '1'},
            success: function (payload) {
              Object.assign(that.currentOrder, {
                crpCertFrontOss: payload.ossPath,
                crpName: payload.ocr.name,
                crpCertNo: payload.ocr.num,
              })
              that.$forceUpdate()
            },
          },
          // crpCertBackOss: {
          //   param: null,
          //   success: function (payload) {
          //     Object.assign(that.currentOrder, {
          //       crpCertBackOss: payload.ossPath
          //     })
          //     that.$forceUpdate()
          //   },
          // },
          opCertFrontOss: {
            param: {ocrType: '1'},
            success: function (payload) {
              Object.assign(that.currentOrder, {
                opCertFrontOss: payload.ossPath,
                opName: payload.ocr.name,
                opCertNo: payload.ocr.num,
              })
              that.$forceUpdate()
            }
          },
          // opCertBackOss: {
          //   param: null,
          //   success: function () {
          //     that.$forceUpdate()
          //   }
          // },
          // opPoaOss: {
          //   param: null,
          //   success: function () {
          //     that.$forceUpdate()
          //   }
          // },
          // matOssArrayJson: {
          //   param: null,
          //   success: function() {
          //   }
          // }
        }, // endof ossSetup

        // opCertFrontOssSuccess(payload) {
        //   Object.assign(this.order, {
        //     opCertFrontOss: payload.ossPath,
        //     opName: payload.ocr.name,
        //     opCertNo: payload.ocr.num,
        //   })
        //   this.$forceUpdate()
        // },
        // opCertBackOssSuccess(payload) {
        // },
        // //法人授权委托书
        // opPoaOssSuccess(payload) {
        // },

        // usccOssSuccess(payload) {
        //   this.showPrompt = false
        //   Object.assign(this.order, {
        //     usccOss: payload.ossPath,
        //     name: payload.ocr.name,
        //     crpName: payload.ocr.person,
        //     uscc: payload.ocr.reg_num,
        //   })
        //   // this.order.company.dist6 = payload.ocr.reg_num.substr(2, 6)
        //   this.order.aicDist6 = payload.ocr.reg_num.substr(2, 6)
        //   this.order.address = payload.ocr.address
        //   // store.dispatch('order/getCompanySelectList', {dist6: this.order.company.dist6}).then(res => this.$forceUpdate())
        // },
        // crpCertFrontOssSuccess(payload) {
        //   Object.assign(this.order, {
        //     crpCertFrontOss: payload.ossPath,
        //     crpName: payload.ocr.name,
        //     crpCertNo: payload.ocr.num,
        //   })
        //   this.$forceUpdate()
        // },
        // crpCertBackOssSuccess(payload) {
        //   Object.assign(this.order, {
        //     crpCertBackOss: payload.ossPath
        //   })
        //   this.$forceUpdate()
        // },
        // usccOssParam: {ocrJson: JSON.stringify({typeId: 3})},
        // certFrontparam: {ocrJson: JSON.stringify({typeId: 1})},
        // form: {
        // //营业执照
        // usccOss: {
        //   name: 'usccOss',
        //   single: true,
        //   param: {ocrJson: JSON.stringify({typeId: 3})},
        //   list: []
        // },
        // //法人身份证正面
        // crpCertFrontOss: {
        //   name: 'crpCertFrontOss',
        //   single: true,
        //   param: {ocrJson: JSON.stringify({typeId: 1})},
        //   list: [],
        //   success(payload, file) {
        //     Object.assign(_this.order, {
        //       crpCertFrontOss: payload.ossPath,
        //       crpName: payload.ocr.name,
        //       crpCertNo: payload.ocr.num,
        //     })
        //     _this.$forceUpdate()
        //   }
        // },
        //   //法人身份证反面
        //   crpCertBackOss: {
        //     name: 'crpCertBackOss',
        //     single: true,
        //     param: {},
        //     list: [],
        //     success(payload, file) {
        //       Object.assign(_this.order, {
        //         crpCertBackOss: payload.ossPath
        //       })
        //       _this.$forceUpdate()
        //     }
        //   },
        //   //经办人身份证正面
        //   opCertFrontOss: {
        //     name: 'opCertFrontOss',
        //     single: true,
        //     param: {ocrJson: JSON.stringify({typeId: 1})},
        //     list: [],
        //     success(payload, file) {
        //       Object.assign(_this.order, {
        //         opCertFrontOss: payload.ossPath,
        //         opName: payload.ocr.name,
        //         opCertNo: payload.ocr.num,
        //       })
        //       _this.$forceUpdate()
        //     }
        //   },
        //   //经办人身份证反面
        //   opCertBackOss: {name: 'opCertBackOss', single: true, param: {}, list: []},
        //   //授权委托书
        //   opPoaOss: {name: 'opPoaOss', single: true, param: {}, list: []},
        //   //授权委托书
        //   matApplyOss: {
        //     name: 'matApplyOss',
        //     single: true,
        //     list: [],
        //     param: {},
        //     succes(payload, file) {
        //       Object.assign(_this.order, {matApplyOss: payload.matApplyOss})
        //       _this.$forceUpdate()
        //     }
        //   },
        //
        //   //授权委托书
        //   matOssArrayJson: {name: 'matOssArrayJson', single: false, param: {}, list: [],},
        //
        //
        // },
      }
    },
    computed: {
      ...mapState({
        currentOrder: state => state.order.currentOrder,
      }),
    },
    methods: {
      validate() {
        let valid =  this.$refs.orderForm.validate()
        console.log("validate", valid)
        return valid
      },

      // 经办人使用法人
      setOpSameWithCrp(op) {
        if (op) { // 相同

        } else { // 不同

        }
        console.log("setOpSameWithCrp", op)
        // if (this.opUseCrp) {
        //   Object.assign(this.order, {
        //     opName: this.order.crpName,
        //     opCertNo: this.order.crpCertNo,
        //     opPhone: this.order.crpPhone,
        //     opCertFrontOss: this.order.crpCertFrontOss,
        //     opCertBackOss: this.order.crpCertBackOss,
        //     opPoaOss: ''
        //   })
        //   Object.assign(this.form.opCertFrontOss, {
        //     list: this.form.crpCertFrontOss.list,
        //     uploadFiles: this.form.crpCertFrontOss.uploadFiles
        //   })
        //   Object.assign(this.form.opCertBackOss, {
        //     list: this.form.crpCertBackOss.list,
        //     uploadFiles: this.form.crpCertBackOss.uploadFiles
        //   })
        //   this.rules = Object.assign({}, this.crpNouseOpRules)
        //   this.aicRules = Object.assign({}, this.aicNoUseRules)
        // } else {
        //   this.rules = Object.assign({}, this.crpNouseOpRules, this.opRules)
        //   this.aicRules = Object.assign({}, this.aicUseRules)
        // }
      },
    },
    created() {
      console.log("OrderCompanySelf created")
    },
    updated() {
      console.log("OrderCompanySelf updated")
    },
  }
</script>
